import React, { useContext, useState } from 'react'

const UserContext = React.createContext()

export function useUser() {
  return useContext(UserContext)
}

// eslint-disable-next-line react/prop-types
export default function UserProvider({ children }) {
  const [user, setUser] = useState({ name: '' })
  const [image, setImage] = useState(null)
  return (
    <UserContext.Provider value={{ user, setUser, image, setImage }}>
      {children}
    </UserContext.Provider>
  )
}
